import { Fragment } from 'react';
import Create from '../components/Create';
import Header from '../components/Header';

const CreatePage = () => {
   return (
      <Fragment>
         <Header />
         <Create />
      </Fragment>
   );
};

export default CreatePage;
